import accounting from 'accounting';
import translations from '../translations/translations';

const Localizer = {
    roundEuro: function (number, locale) {
        // first decimal to in
        const value = accounting.formatMoney(number, "", 0, ".");
        switch (locale) {
            case 'nl':
                return '€\xa0' + value + ',-';
            case 'de':
                return value + ',-\xa0€';
            case 'en':
                return '€' + value + ',-';
			case 'fr':
				return '€' + value + ',-';
			case 'es':
				return '€' + value + ',-';
            case 'it':
                return '€' + value + ',-';
            default:
                return '€\xa0' + value + ',-';
        }
    },

    translate: function (phrase, locale) {
        return translations[locale][phrase];
    }
};

export default Localizer;
